<template>
  <el-select
    v-model="typesMailModel"
    @change="typesMailChanged"
    autocomplete="new-password"
    :placeholder="$t('TEMPLATES_MAILS.TYPE')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getTypesMails"
    :loading="loading"
  >
    <el-option
      v-for="(typesMail, key) in typesMails"
      :key="key"
      :value="typesMail.id"
      :label="`${typesMail.label}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "types-mail-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    allowCreate: {
      type: Boolean,
      default: false,
      description: "Allow tag creation",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    typesMail: {
      type: String,
      default: null,
      description: "typesMail id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
  },

  data() {
    return {
      typesMailModel: this.typesMail,
      typesMails: {},
    };
  },

  setup() {},

  created() {
    this.getTypesMails(null, this.typesMail);
  },

  methods: {
    async getTypesMails(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          sort: "label",
          filter: {
            ...(query ? { search: query } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        await this.$store.dispatch("typesMails/list", params);
        const typesMailsArr = await this.$store.getters["typesMails/list"];
        this.typesMails = {};
        typesMailsArr.forEach((typesMail) => {
          this.typesMails[typesMail.id] = typesMail;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    typesMailChanged(typesMail) {
      this.$emit("typesMailChanged", typesMail);
    },
  },

  watch: {
    typesMail(typesMail) {
      if (typesMail) {
        this.typesMailModel = typesMail;
        if (typesMail !== this.typesMailModel) {
          this.getTypesMails(null, typesMail);
        }
      } else {
        this.typesMailModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getTypesMails();
    },
  },
};
</script>
